import { useTranslation } from 'react-i18next';
import { Step } from 'react-joyride';

import { useAuth } from '@/shared/hooks/context/auth';

export const useDemoSteps = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const steps: Step[] = [
    {
      target: '.demo-first-step',
      title: t('demo-first-step-title', { user: user?.firstName }),
      content: t('demo-first-step-content'),
      placement: 'left-start',
      disableBeacon: true,
      styles: {
        spotlight: {
          borderRadius: 8,
        },
      },
    },
    {
      target: '.demo-second-step',
      title: t('demo-second-step-title'),
      content: t('demo-second-step-content'),
      placement: 'right',
      styles: {
        spotlight: {
          borderRadius: 8,
        },
      },
    },
    {
      target: '.demo-third-step',
      title: t('demo-third-step-title'),
      content: t('demo-third-step-content'),
      placement: 'right',
      styles: {
        spotlight: {
          borderRadius: 8,
        },
      },
    },
    {
      target: '.demo-fourth-step',
      title: t('demo-fourth-step-title'),
      content: t('demo-fourth-step-content'),
      placement: 'right',
      styles: {
        spotlight: {
          borderRadius: 8,
        },
      },
    },
    {
      target: '#hubspot-messages-iframe-container',
      title: t('demo-fifth-step-title'),
      content: t('demo-fifth-step-content'),
      placement: 'right',
      styles: {
        spotlight: {
          borderRadius: '100%',
        },
      },
    },
  ];

  return { steps };
};
